import clubRequest from "../axios";

const getServicePrices = async () =>
  (await clubRequest.servicePriceList()).data;

const servicePriceService = {
  getServicePrices,
};

export default servicePriceService;
